import { Permissions, ROLES } from "app/constants";
import FilterProvider from "components/FilterProvider";
import BoatList from "features/boats/BoatList";
import BookingDocumentList from "features/booking-documents/BookingDocumentList";
import BookingForm from "features/bookings/BookingForm";
import BookingList from "features/bookings/BookingList";
import GlobalOnlineCheckModal from "features/bookings/GlobalOnlineCheckModal";
import BulkEmailSentList from "features/bulk-emails-sent/BulkEmailSentList";
import CateringBookingList from "features/catering/CateringBookingList";
import CateringPage from "features/catering/CateringPage";
import { CommissionReportView } from "features/commission-reports";
import EmailPreviewPage from "features/email-preview/EmailPreviewPage";
import EmailTemplateList from "features/email-templates/EmailTemplateList";
import EventList from "features/events/EventList";
import ExchangeRateForm from "features/exchange-rates/ExchangeRateForm";
import ExchangeRateList from "features/exchange-rates/ExchangeRateList";
import ExchangeRateProvider from "features/exchange-rates/ExchangeRateProvider";
import FileList from "features/files/FileList";
import HistoryList from "features/histories/HistoryList";
import HostBookingList from "features/host/HostBookingList";
import HostPage from "features/host/HostPage";
import KitchenBookingList from "features/kitchen/KitchenBookingList";
import KitchenPage from "features/kitchen/KitchenPage";
import NotificationAddressList from "features/notification-addresses/NotificationAddressList";
import OptionGroupList from "features/option-groups/OptionGroupList";
import { PartnerFeedList } from "features/partner-feeds";
import PartnerGroupList from "features/partner-groups/PartnerGroupList";
import PartnerList from "features/partners/PartnerList";
import PaymentTransactionForm from "features/payment-transactions/PaymentTransactionForm";
import PaymentTransactionList from "features/payment-transactions/PaymentTransactionList";
import PermissionForm from "features/permissions/PermissionForm";
import ProfileForm from "features/profile/ProfileForm";
import useAccess from "features/profile/useAccess";
import ProgramForm from "features/programs/ProgramForm";
import ProgramList from "features/programs/ProgramList";
import RedflagPartnerList from "features/redflag-partners/RedflagPartnerList";
import AdvancedReport from "features/reports/AdvancedReport/AdvancedReport";
import CoordinatorReport from "features/reports/CoordinatorReport/CoordinatorReport";
import CoordinatorReport2 from "features/reports/CoordinatorReport/CoordinatorReport2";
import CoordinatorReport3 from "features/reports/CoordinatorReport/CoordinatorReport3";
import DailyTripsReport from "features/reports/DailyTripsReport/DailyTripsReport";
import DynamicPricingReport from "features/reports/DynamicPricingReport/DynamicPricingReport";
import { PivotReport } from "features/reports/PivotReport";
import SalesReport from "features/reports/SalesReport/SalesReport";
import SimpleReport from "features/reports/SimpleReport/SimpleReport";
import ReviewEmailSentList from "features/review-email-sents/ReviewEmailSentList";
import { ReviewPartnerList } from "features/review-partners";
import RoleForm from "features/roles/RoleForm";
import RoleList from "features/roles/RoleList";
import RoleTabs from "features/roles/RoleTabs";
import SalesPersonList from "features/sales-persons/SalesPersonList";
import ScheduleForm from "features/schedules/ScheduleForm";
import ScheduleList from "features/schedules/ScheduleList";
import ScheduleTabs from "features/schedules/ScheduleTabs";
import SeatingLayoutList from "features/seating-layouts/SeatingLayoutList";
import StreetSalesPage from "features/street-sales/StreetSalesPage";
import UserActivityList from "features/users/UserActivityList";
import UserForm from "features/users/UserForm";
import UserList from "features/users/UserList";
import UserTabs from "features/users/UserTabs";
import { WebSocketProvider } from "features/websoket/WebSocketProvider";
import AdminLayout from "layouts/Admin/AdminLayout";
import Home from "pages/home/Home";
import PageNotFound from "pages/page-not-found/PageNotFound";
import { Navigate, Route, Routes } from "react-router-dom";

export default function AdminRouter() {
  const { hasRoles, notHasRoles, hasPermissions } = useAccess();
  let initialPath = "/";
  if (hasRoles(ROLES.HEAD_OFFICE)) {
    initialPath = "/reports/simple";
  } else if (hasRoles(ROLES.CATERING)) {
    initialPath = "catering";
  } else if (hasRoles(ROLES.STREET_SALES)) {
    initialPath = "/street-sales";
  } else if (hasRoles(ROLES.KITCHEN)) {
    initialPath = "/kitchen";
  } else if (hasRoles(ROLES.HAZIASSZONYOK)) {
    initialPath = "/host";
  }

  return (
    <WebSocketProvider>
      <ExchangeRateProvider>
        <Routes>
          <Route path="/login" element={<Navigate to={initialPath} />} />
          <Route path="/" element={<AdminLayout />}>
            {hasPermissions(Permissions.CalendarMenu) && (
              <Route path="" element={<Home />} />
            )}
            {hasPermissions(Permissions.KitchenMenu) && (
              <Route path="kitchen" element={<KitchenPage />}>
                <Route
                  path=":start/:boat_id"
                  element={<KitchenBookingList />}
                />
              </Route>
            )}
            {hasPermissions([
              Permissions.ReportMenuSimple,
              Permissions.ReportMenuAdvanced,
              Permissions.ReportMenuSales,
              Permissions.ReportMenuControlling,
              Permissions.ReportMenuCommission,
              Permissions.ReportMenuCoordinator,
              Permissions.ReportMenuCoordinatorStreet,
              Permissions.ReportMenuCoordinatorWeb,
              Permissions.ReportMenuDailyTrips,
            ]) && (
              <Route path="reports">
                {hasPermissions(Permissions.ReportMenuSimple) && (
                  <Route path="simple" element={<SimpleReport />} />
                )}
                {hasPermissions(Permissions.ReportMenuAdvanced) && (
                  <>
                    <Route path="advanced" element={<AdvancedReport />} />
                    <Route
                      path="dynamic-pricing"
                      element={<DynamicPricingReport />}
                    />
                  </>
                )}
                {hasPermissions(Permissions.ReportMenuControlling) && (
                  <Route path="controlling" element={<PivotReport />} />
                )}
                {hasPermissions(Permissions.ReportMenuSales) && (
                  <Route path="sales" element={<SalesReport />} />
                )}
                <Route path="coordinator" element={<CoordinatorReport />} />
                <Route path="coordinator-2" element={<CoordinatorReport2 />} />
                <Route path="coordinator-3" element={<CoordinatorReport3 />} />
                {hasPermissions(Permissions.ReportMenuDailyTrips) && (
                  <Route path="daily-trips" element={<DailyTripsReport />} />
                )}
                {hasPermissions(Permissions.ReportMenuCommission) && (
                  <Route path="commission" element={<CommissionReportView />} />
                )}
              </Route>
            )}
            {hasPermissions(Permissions.CateringMenu) && (
              <Route path="catering" element={<CateringPage />}>
                <Route
                  path=":start/:boat_id"
                  element={<CateringBookingList />}
                />
              </Route>
            )}
            {hasPermissions(Permissions.HostMenu) && (
              <Route path="host" element={<HostPage />}>
                <Route path=":start/:boat_id" element={<HostBookingList />} />
              </Route>
            )}
            {hasPermissions(Permissions.StreetMenu) && (
              <Route path="street-sales" element={<StreetSalesPage />} />
            )}
            <Route path="users">
              <Route path="" element={<UserList />} />
              <Route path=":user_id" element={<UserTabs />}>
                <Route path="permissions" element={<PermissionForm />} />
                <Route path="activity" element={<UserActivityList />} />
                <Route path="" element={<UserForm />} />
              </Route>
            </Route>
            <Route path="seating-layouts" element={<SeatingLayoutList />} />
            <Route path="redflag-partners" element={<RedflagPartnerList />} />
            <Route
              path="notification-addresses"
              element={<NotificationAddressList />}
            />
            <Route path="partner-groups" element={<PartnerGroupList />} />
            <Route path="partner-feeds" element={<PartnerFeedList />} />
            <Route path="email-templates" element={<EmailTemplateList />} />
            <Route path="bulk-emails-sent" element={<BulkEmailSentList />} />
            <Route path="review-partners" element={<ReviewPartnerList />} />
            <Route
              path="review-email-sents"
              element={<ReviewEmailSentList />}
            />
            <Route path="partners" element={<PartnerList />} />
            <Route path="sales-persons" element={<SalesPersonList />} />
            <Route path="programs">
              <Route path="" element={<ProgramList />} />
              <Route path=":program_id" element={<ProgramForm />} />
            </Route>
            <Route path="option-groups" element={<OptionGroupList />} />
            <Route path="boats" element={<BoatList />} />
            <Route path="schedules">
              <Route
                path=""
                element={
                  <FilterProvider id="schedules.main" storageType="session">
                    <ScheduleList />
                  </FilterProvider>
                }
              />
              <Route path=":schedule_id" element={<ScheduleTabs />}>
                <Route path="" element={<ScheduleForm />} />
                <Route
                  path="events"
                  element={
                    <EventList id="schedule.events" showHeader={false} />
                  }
                />
              </Route>
            </Route>
            <Route
              path="events"
              element={
                <FilterProvider id="events.main" storageType="session">
                  <EventList id="main" />
                </FilterProvider>
              }
            />
            <Route path="bookings">
              <Route
                path=""
                element={
                  <FilterProvider id="bookings.main" storageType="session">
                    <BookingList id="main" />
                  </FilterProvider>
                }
              />
              <Route path=":booking_id" element={<BookingForm />} />
            </Route>
            <Route
              path="notify-bookings"
              element={
                <FilterProvider
                  key="bookings.notify"
                  id="bookings.notify"
                  storageType="session"
                >
                  <BookingList
                    id="notify"
                    customScope="shouldNotify"
                    renderToolbarLeftItems={undefined}
                  />
                </FilterProvider>
              }
            />
            <Route
              path="web-comment-bookings"
              element={
                <FilterProvider
                  key="bookings.webComment"
                  id="bookings.webComment"
                  storageType="session"
                >
                  <BookingList
                    id="webComment"
                    customScope="webComment"
                    renderToolbarLeftItems={undefined}
                  />
                </FilterProvider>
              }
            />
            <Route
              path="refund-eligible-bookings"
              element={
                <FilterProvider
                  key="bookings.refundEligible"
                  id="bookings.refundEligible"
                  storageType="session"
                >
                  <BookingList
                    id="refundEligible"
                    customScope="refundEligible"
                    renderToolbarLeftItems={undefined}
                  />
                </FilterProvider>
              }
            />
            <Route path="exchange-rates">
              <Route path="" element={<ExchangeRateList />} />
              <Route path=":exchange_rate_id" element={<ExchangeRateForm />} />
            </Route>
            <Route path="payment-transactions">
              <Route path="" element={<PaymentTransactionList />} />
              <Route
                path=":payment_transaction_id"
                element={<PaymentTransactionForm />}
              />
            </Route>
            <Route path="history" element={<HistoryList />} />
            <Route path="roles">
              <Route path="" element={<RoleList />} />
              <Route path=":role_id" element={<RoleTabs />}>
                <Route path="" element={<RoleForm />} />
                <Route path="permissions" element={<PermissionForm />} />
              </Route>
            </Route>
            <Route
              path="booking-documents"
              element={
                <FilterProvider
                  id="booking-documents.main"
                  storageType="session"
                >
                  <BookingDocumentList />
                </FilterProvider>
              }
            />
            <Route path="files" element={<FileList />} />
            <Route path="email-preview" element={<EmailPreviewPage />} />
            <Route path="profile" element={<ProfileForm />} />
            {hasRoles([ROLES.HAZIASSZONYOK, ROLES.STREET_SALES]) && (
              <Route path="/" element={<Navigate to={initialPath} />} />
            )}
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
        <GlobalOnlineCheckModal />
      </ExchangeRateProvider>
    </WebSocketProvider>
  );
}
